export default "__VITE_ASSET__3b78c2b8__"